var exports = {
  "_K": "traceDetails__ck4-V-",
  "wx": "header__nIrD9R",
  "fJ": "traceName__8e3_H1",
  "p0": "duration__eg4oVs",
  "uW": "section__YkiAfs",
  "tp": "table__QOCWTj",
  "xR": "tableCell__-HeUoC",
  "jD": "tableRow__cpC632",
  "Gf": "sectionTitle__3hQrME",
  "lu": "expandable__E_czf1",
  "Cz": "expandableContent__WYq0FV",
  "N1": "wrappedPre__hNdpNC",
};

module.exports = exports;
